export default __webpack_public_path__ + "static/media/icons_controls.6445cf21.svg";